(function() {
  // Function to check if device is mobile or tablet
  function isMobileOrTablet() {
    return window.innerWidth <= 1024;
  }

  // Function to move header__heading-link
  function moveHeaderHeadingLink() {
    if (isMobileOrTablet()) {
      console.log('isMobileOrTablet');
      const headerHeadingLink = document.querySelector('.header__heading-link');
      const header = document.querySelector('.header');
      const headerLeftLogo = document.querySelector('.header--left-logo');

      // Only proceed if we have the link and necessary container elements
      if (headerHeadingLink && header && headerLeftLogo) {
        // Check if the link needs to be moved (i.e., hasn't been moved already)
        if (!headerHeadingLink.classList.contains('visible')) {
          console.log('Moving header heading link');

          // Remove from current position
          if (headerHeadingLink.parentElement) {
            headerHeadingLink.parentElement.removeChild(headerHeadingLink);
          }

          // Insert as second child of header
          if (header.children.length >= 2) {
            header.insertBefore(headerHeadingLink, header.children[1]);
          } else {
            header.appendChild(headerHeadingLink);
          }

          // Add styles after movement
          const style = document.createElement('style');
          style.textContent = `
            @media screen and (max-width: 1024px) {
              .header--left-logo {
                display: grid;
                grid-template-columns: 1fr auto 1fr;
                gap: 0.8rem;
              }
            }
          `;
          document.head.appendChild(style);

          // Add visible class after movement
          headerHeadingLink.classList.add('visible');
        }
      }
    }
  }

  // Apply on load and resize
  window.addEventListener('load', moveHeaderHeadingLink);
  window.addEventListener('resize', moveHeaderHeadingLink);
})();